var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomers = function SvgCustomers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 2.5c3.032 0 5.5 2.467 5.5 5.5 0 1.458-.483 3.196-3.248 5.59 4.111 1.961 6.602 5.253 7.482 8.909H2.248c.955-4.188 4.005-7.399 7.519-8.889C8.166 12.323 6.5 10.287 6.5 8c0-3.033 2.468-5.5 5.5-5.5Zm0-2A7.5 7.5 0 0 0 4.5 8c0 2.012.797 3.834 2.086 5.182C1.556 16.191 0 21.683 0 24.5h24c0-2.791-1.657-8.28-6.59-11.314A7.47 7.47 0 0 0 19.5 8 7.5 7.5 0 0 0 12 .5Z"
  })));
};
export default SvgCustomers;